<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="3">
        <YearsComponent @change="onYearSelected" />
      </el-col>
      <el-col :span="3">
        <MonthsComponent :initial="month" @change="OnMonthSelected" />
      </el-col>
      <el-col :span="3">
        <PaymentAndInvoiceTypeSelector
          @PaymentTypeSelected="OnPaymentTypeSelected"
        />
      </el-col>
      <el-col :span="3">
        <PaymentAndInvoicePaid @OnExecutionSelected="OnExecutionSelected" />
      </el-col>
      <el-col :span="3">
        <PaymentsAndInvoicesSelector @PaymentSelected="OnPaymentSelected" />
      </el-col>
      <el-col :span="3">
        <InvoiceType
          :initialValue="invoiceType"
          :isClearable="true"
          inputSize="mini"
          @OnInvoiceTypeSelected="OnInvoiceTypeSelected"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import YearsComponent from "@/components/Global_System/YearsComponent";
import MonthsComponent from "@/components/Global_System/MonthsComponent";
import PaymentsAndInvoicesSelector from "@/components/fiances/reports/filters/PaymentsAndInvoicesSelector";
import PaymentAndInvoiceTypeSelector from "@/components/fiances/reports/filters/PaymentAndInvoiceTypeSelector";
import PaymentAndInvoicePaid from "@/components/fiances/reports/filters/PaymentAndInvoicePaid";
import InvoiceType from "@/components/calendar/selectors/InvoiceType";

const actualMonth = new Date().getMonth() + 1;

export default {
  name: "ClientRabbeyPaymentAndInvoicingReportFilters",
  components: {
    YearsComponent,
    MonthsComponent,
    PaymentsAndInvoicesSelector,
    PaymentAndInvoiceTypeSelector,
    PaymentAndInvoicePaid,
    InvoiceType
  },
  data() {
    return {
      month: actualMonth,
      invoiceType: ""
    };
  },

  mounted() {},

  methods: {
    onYearSelected(year) {
      this.$emit("onYearSelected", year);
    },
    OnMonthSelected(month) {
      this.$emit("onMonthSelected", month);
    },
    OnPaymentTypeSelected(value) {
      this.$emit("onPaymentTypeSelected", value);
    },
    OnExecutionSelected(value) {
      this.$emit("ExecutionSelected", value);
    },
    OnPaymentSelected(value) {
      this.$emit("PaymentSelected", value);
    },
    OnInvoiceTypeSelected(type) {
      this.invoiceType = type;
      this.$emit("OnInvoiceTypeSelected", type);
    }
  }
};
</script>

<style scoped></style>
